var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _path5, _rect, _rect2, _rect3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDryeraseBoard = function SvgDryeraseBoard(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 606.27 613.33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.31 156.44h466.41v296.41H68.31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M530.56 471.24H85.93a27.53 27.53 0 0 1-27.5-27.5V161.37a27.54 27.54 0 0 1 27.5-27.5h444.63a27.54 27.54 0 0 1 27.5 27.5v282.37a27.53 27.53 0 0 1-27.5 27.5zM85.93 156.87a4.51 4.51 0 0 0-4.5 4.5v282.37a4.51 4.51 0 0 0 4.5 4.5h444.63a4.51 4.51 0 0 0 4.5-4.5V161.37a4.51 4.51 0 0 0-4.5-4.5z",
    fill: "#6e5f91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ab4e5",
    d: "M534.72 179.33h23.68v251.73h-23.68zM509.82 448.01v23.68H105.95v-23.68zM509.83 133.35v23.68H105.96v-23.68zM58.5 179.33h23.68v251.73H58.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6842d",
    d: "M130.15 470.29h370.24v17.98H130.15z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 426.73,
    cy: 210.28,
    r: 16.24,
    fill: "#015e85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.89,
    cy: 210.28,
    r: 16.24,
    fill: "#f0592b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.73,
    cy: 256.15,
    r: 16.24,
    fill: "#93b847"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.89,
    cy: 256.15,
    r: 16.24,
    fill: "#fdb73e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.22 439.23h119.33v25.69a7 7 0 0 1-7 7H159.22a7 7 0 0 1-7-7v-25.69z",
    fill: "#015e85"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 146.22,
    y: 422.82,
    width: 128.77,
    height: 18.04,
    rx: 1,
    fill: "#6ab4e5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 307.88,
    y: 458.85,
    width: 112.41,
    height: 12.08,
    rx: 3,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 419.67,
    y: 458.85,
    width: 32.59,
    height: 12.08,
    rx: 3,
    fill: "#ef6ba0"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDryeraseBoard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dryerase_board.3eb44d78.svg";
export { ForwardRef as ReactComponent };